module.exports = {"engravedIdLabel":"OV-Chipkartennummer","checkEligibilityButton":"Überprüfen","productConfigurationLabel":"Das zu bestellende Produkt auswählen","configurationForm":{"submit":"Produkt wählen"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/special-sale.json
// module id = k/gd
// module chunks = 1